import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MediaModule } from "@suvo-media/modules/media";
import { ITileInstance } from "../../../interfaces/tiles/definition-helpers/tile-definition.interface";

export interface ILinkBannerConfiguration {
  text: string;
}

export type TLinkBannerInstance = ITileInstance & { configuration: ILinkBannerConfiguration };

@Component({
  selector: 'link-banner-b-tile',
  standalone:true,
  imports: [
    CommonModule,
    MediaModule,
  ],
  template: `
    @if(tileInstance.configuration) {
      <a [href]="tileInstance.configuration.href">
        <media-image [imageId]="tileInstance.configuration.image" />
      </a>
    } @else {
      It has not been configured yet.
    }
  `
})
export class LinkBannerBTileComponent {
  @Input() tileInstance!: ITileInstance & { configuration: TLinkBannerInstance};
}
